<!-- Translated: yes -->
<template>
  <Modal @close="closeLocalModal" :setClass="['no-padding']" width="500px">
    <Loading :show="loading" />
    <div :class="{header: true, disabled: loading}" slot="header">
      <h2 class="uppercase">{{ school.full_title || school.subtitle }}</h2>

      <div class="info-box">
        <div v-if="!params.activity"><icon name="calendar-blue" :scale="1.1" /> <b>{{ $t('general.days-count') }}:</b> {{school.actual_days}} {{ $t('general.days') }}</div>
        <div><icon name="clock" :scale="1.1" /> {{school.minutes}}{{ $t('general.minutes-short') }}<span v-if="!params.activity">/{{ $t('skischool.lesson') }}</span></div>
        <!--<div v-if="school.time_start">{{school.time_start.substr(0, 5)}}-{{school.time_end.substr(0, 5)}}</div>-->
      </div>

      <div class="location">
        <div
          class="label"
          style="cursor:pointer;"
          @click="openModal(['SkiSchoolLocationMap'])"
          >{{ $t('skischool.gathering-site') }} <icon name="info-blue-white-bg" :scale="1.3" /></div>

        <div>
          <div class="location-box" v-if="SITE_CONFIG.skischool.show_site">
            <strong v-if="school.site === 2"><icon name="berget" :scale="1.6" /> {{ school.site_name }}</strong>
            <strong v-if="school.site === 1"><icon name="byn" :scale="1.6" /> {{ school.site_name }}</strong>
            <strong v-if="!school.site"><icon name="gondol" :scale="1.6" /> {{ school.site_name }}</strong>
            <p>{{ $t('skischool.branas.site-this-school', {site: school.site_name_help}) }}</p>
            <p v-if="showMinParticipantsReq">{{groupParticipantsRequirementText}}</p>
            <p v-if="lowParticipantCountVariations && SITE_CONFIG.site === 'branas'">{{lowParticipantCountVariationText}}</p>
          </div>

          <div class="location-box" v-if="!SITE_CONFIG.skischool.show_site">
            <div v-if="$route.name === 'ski school overview'">
              <strong>{{ $t('skischool.kungsberget.site.title') }}</strong>
              <p>{{ $t('skischool.kungsberget.site.description') }}</p>
              <p>{{ $t('skischool.kungsberget.site-help') }}</p>
            </div>
            <div v-if="$route.name === 'bike school overview'">
              <strong>Bron</strong>
              <p>Vi samlas på bron mellan hyran och 8stols liften.</p>
              <p>Cykel och skyddsutrustning ingår ej i aktivitetsbokningen, men kan förbokas på <a href="https://hyra.kungsberget.se">hyra.kungsberget.se</a>. Som deltagare tar du själv med dig liftkort.</p>
              <p>Kungsberget förbehåller sig rätten att vid 2 elever eller färre, ställa in kursen eller erbjuda ett annat kurstillfälle.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="location" v-if="school.notice">
        <div class="label">Viktig information</div>
        <div>
          <div class="location-box notice">
            <p>{{ school.notice }}</p>
          </div>
        </div>
      </div>
    </div>

    <div :class="{main: true, disabled: loading}">

      <div class="field size-75">
        <label>{{ $t('general.pick-startdate') }}<span class="required">*</span></label>
        <Dropdown
          prefixicon="calendar"
          prefixicon-validated="calendar-white"
          ref="dateDropdown"
          tabindex="0"
          :options="[]"
          :label="theBooking.theDate ? (moment(theBooking.theDate).format('D MMMM')) : $t('general.pick-startdate')"
          @clicked="openDateModal"
          :bold-label="false"
          :validated="theBooking.theDate"
          @clicked-suffix="dateClear">
        </Dropdown>
      </div>

      <div :class="{field: true, 'size-25': true, 'fully-disabled': !theBooking.theDate}" v-if="!$route.query.qty">
        <label for="">{{ $t('general.number') }}<span class="required">*</span></label>
        <Dropdown
          :combo="false"
          :options="options"
          :valuebinder.sync="qty"
          :validated="theBooking.people.length && qty && theBooking.theDate"
          />
      </div>

      <div class="field" v-if="theBooking.theDate">
        <label>{{ $t('general.pick-time') }}</label>
        <div class="checkboxes">
          <div v-for="time in times">
            <Checkbox
              :label="time.title"
              label-position="after"
              :value="time.value"
              :valuebinder.sync="theBooking.time"
              @click="checkAvailability"
              />
          </div>
        </div>
      </div>

      <div class="error" v-if="!available">
        <p v-html="reason"></p>
      </div>

      <div class="info" v-if="restrictionDateInfo">
        <p v-html="restrictionDateInfo"></p>
      </div>

      <div class="info" v-if="bookingWarning">
        <p v-html="bookingWarning"></p>
      </div>

      <div class="info" v-if="alreadyBooked">
        <div><b>Flera elever</b></div>
        <div>
          <div class="location-box notice">
            <p>{{ alreadyBookedMessage }}</p>
          </div>
        </div>
      </div>

      <hr style="width:100%;">

      <div class="field flex" v-for="(person, index) in theBooking.people" v-if="!$route.query.qty">
        <div class="field size-75">
          <label for="" v-if="theBooking.people.length == 1">{{ $t('general.name-on') }} {{
            school.maxage <= 11 ?
              ($t('general.ages.the-child'))
              : (school.maxage >= 17 ? $t('general.the-skier') : $t('general.youth'))
          }}<span class="required">*</span></label>
          <label for="" v-else>{{ $t('general.name-on') }} {{
            school.maxage <= 11 ?
              ($t('general.ages.child'))
              : (school.maxage >= 17 ? $t('general.skier') : $t('general.skier'))
          }} {{index + 1}}<span class="required">*</span></label>
          <input type="text" class="input" v-model="person.name" :placeholder="$t('general.first-and-surname')" />
        </div>

        <div class="field size-25">
          <label>{{ $t('general.age') }}<span class="required">*</span></label>
          <Dropdown
            :combo="true"
            :options="ages"
            :valuebinder.sync="person.age"
            :validated="person.age !== '' && (person.age >= school.minage && person.age <= school.maxage)"
            :label="$t('general.age')"
            />
        </div>

        <div class="field" v-if="showComments">
          <div>
            <div style="display:flex;justify-content:space-between;align-items:center;">
              <label for="">{{ $t('skirental.wishes.title') }}<span class="required">*</span></label>
              <button class="white small border" style="margin-top: 14px;" @click="(e) => openWishes(index)" v-if="getWishesAsList(person.wishes).length">
                <icon name="edit-blue" :scale="1" />
                Ändra
              </button>
            </div>
            <div v-if="getWishesAsList(person.wishes).length">
              <ul style="margin-top:0.5rem;">
                <li v-for="wish in getWishesAsList(person.wishes)" :key="wish">{{ wish }}</li>
              </ul>
            </div>
            <div v-if="!getWishesAsList(person.wishes).length">
              <p style="font-size:15px;">När du bokar privatlektion uppskattar vi om du anger önskemål.</p>
              <button class="small border" @click="(e) => openWishes(index)">
                <icon name="plus-white" :scale="1" />
                {{ $t('skirental.wishes.add') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr style="width:100%;" v-if="theBooking.people.length && !$route.query.qty">

      <div class="field" v-if="showGuardian && (SITE_CONFIG.site !== 'vallasen' && SITE_CONFIG.site !== 'ulricehamn')">
        <div>
          <label for="">{{ $t('general.name-guardian') }}<span class="required">*</span></label>
          <input type="text" class="input" v-model="theBooking.guardian" :placeholder="$t('general.first-and-surname')" />
        </div>
      </div>
      <div class="field">
        <label for="">{{ $t('general.phone') }}<span class="required">*</span></label>
        <input type="tel" class="input" v-model="theBooking.phone"  @blur="fixPhone" :placeholder="$t('general.phone-number')" />
        <div class="phone-number">{{ $t('general.obs-format', {format: '+46701234567'}) }}</div>
      </div>

      <hr style="width:100%;">
      <p class="info-call" v-html="$t('general.special-needs-call', {phone: `<b>${bookingNumber}</b>`})"></p>
      <p class="info-group-requirements" v-if="showMinParticipantsReq && SITE_CONFIG.site === 'branas'">{{groupParticipantsRequirementText}}</p>
    </div>
    <div :class="{footer: true, disabled: loading}" v-if="!loadingAvailability" slot="footer">
      <div class="price" v-if="!params.activity">{{ $t('general.price-per-person') }} <span>{{price | currency}}</span></div>
      <div class="price" v-if="params.activity">{{ $t('general.price') }}: <span>{{price | currency({freeIfZero: true})}}</span></div>
      <button :disabled="!validated()" @click="addToCart()">{{$store.state.isOnSite ? $t('general.pay-with-card') : $t('general.cta.book')}} <icon name="cart-white" :scale="1.4" @click="addToCart" v-if="!$store.state.isOnSite" /></button>
    </div>

    <div :class="{footer: true, disabled: loading}" slot="footer" style="padding-top: 0;">
      <div style="text-align:right;width:100%;">
        <button :disabled="!validated()" :class="'small white border'" @click="openCodeModal()" v-if="$store.state.isOnSite" style="display:inline-block;">{{ $t('general.pay-cash') }}</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import DatepickerButton from '@/components/components/DatepickerButton';
import Dropdown from '@/components/components/Dropdown';
import TextInput from '@/components/components/TextInput';
import Checkbox from '@/components/components/Checkbox';
import Loading from '@/components/components/Loading';

import API from '@/classes/API';
import moment from 'moment';

import restrictions from '@/mixins/restrictions';
import schoolWishes from '@/mixins/schoolWishes';

export default {
  props: ['params'],
  components: {
    Modal,
    DatepickerButton,
    Dropdown,
    TextInput,
    Checkbox,
    Loading,
  },
  mixins: [restrictions, schoolWishes],
  data() {
    return {
      dates: {},
      school: {
        subtitle: 'Laddar...',
      },
      qty: 1,
      changes: 0,
      available: true,
      total_price: null,
      lockingCode: '',
      reason: null,
      bookingWarning: '',
      theBooking: {
        theDate: null,
        people: [],
        guardian: '',
        phone: '',
        time: '',
      },
      loading: true,
      loadingAvailability: false,
      alreadyBookedShowedWarning: false,
      forceAlreadyBookedMessage: false,
      currentIndex: -1,
    };
  },
  beforeMount() {
    this.fetch();
    this.theBooking = Object.assign(this.theBooking, this.$store.state.skiSchoolBooking);

    if (!this.theBooking.theDate && this.$store.state.skiSchoolFilter.date) {
      this.theBooking.theDate = moment(this.$store.state.skiSchoolFilter.date).toDate();
    }

    if (!this.theBooking.phone) {
      this.theBooking.phone = '+46';
    }

    if (!this.theBooking.people || !this.theBooking.people.length) {
      this.theBooking.people = [];
      // this.addPerson();
    }

    this.qty = this.theBooking.people.length;

    if (window.SKISCHOOL_alreadyBookedShowedWarning) {
      this.alreadyBookedShowedWarning = true;
    }
  },
  watch: {
    qty(newQty) {
      const currentQty = this.theBooking.people.length;
      let diff = newQty - currentQty;

      if (diff > 0) {
        while (diff > 0) {
          this.addPerson();
          diff -= 1;
        }
      } else if (diff < 0) {
        while (diff < 0) {
          this.removePerson();
          diff += 1;
        }
      }
      this.checkAvailability();

      if (this.school.is_private && this.alreadyBookedShowedWarning === false && newQty > 1) {
        this.forceAlreadyBookedMessage = true;
      } else {
        this.forceAlreadyBookedMessage = false;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.alreadyBooked && this.alreadyBookedShowedWarning === false) {
        this.showAlreadyBookedModal();
      }

      this.checkAvailability(() => {
        if (this.$route.query.qty) {
          this.qty = parseInt(this.$route.query.qty, 10);
        }
      });
    }, 500);

    this.school.subtitle = this.$i18n.t('general.loading');
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
      'addSkiSchoolToCart',
      'addActivitityToCart',
      'saveCartLocking',
      'consolidateSkiSchoolInCart',
    ]),
    showAlreadyBookedModal() {
      const $this = this;
      window.SKISCHOOL_alreadyBookedShowedWarning = true;

      this.openModal(['GeneralModal', {
        title: 'Flera elever',
        content: this.alreadyBookedMessage,
        buttons: [
          {
            title: 'Okej',
            class: 'small',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    moment(d) {
      return moment(d);
    },
    async checkAvailability(onDone) {
      this.loadingAvailability = true;

      console.log('Checking availability...');
      let success = true;
      let reason = '';
      let warning = '';
      let price = null;

      let peopleCount = this.theBooking.people.length;

      if (!peopleCount) {
        peopleCount = this.school.min_participants;
      }

      if (this.theBooking.time) {
        // Since all the ages has the same cost, and <=15 seems to crash, we send all ages as 30.
        const ages = this.theBooking.people.map(() => 30).join(',');
        const extraAges = this.alreadyBookedAges.map(() => 30).join(',');
        // const ages = this.theBooking.people.map(p => (p.age ? p.age : 30)).join(',');
        // const extraAges = this.alreadyBookedAges.join(',');

        ({ success, reason, warning, price } = await API.get(`/skischool/check-availability/${this.theBooking.time}/${peopleCount}?ages=${ages}&extra-ages=${extraAges}`));
      }

      this.available = success;
      this.reason = reason;
      this.bookingWarning = warning;

      if (price) {
        this.total_price = price;
      } else {
        this.total_price = null;
      }

      if (typeof onDone === 'function') {
        onDone();
      }

      this.loadingAvailability = false;

      return this.available;
    },
    async reserve() {
      console.log('Reserving...');
      let success = true;
      let code = '';
      let before_time = ''; // eslint-disable-line

      let peopleCount = this.theBooking.people.length;

      if (!peopleCount) {
        peopleCount = this.school.min_participants;
      }

      if (this.theBooking.time) {
        if (this.$store.state.lockingCode) {
          ({ success, code, before_time } = await API.get(`/skischool/reserve/${this.theBooking.time}/${peopleCount}/${this.$store.state.lockingCode}`));
        } else {
          ({ success, code, before_time } = await API.get(`/skischool/reserve/${this.theBooking.time}/${peopleCount}`));
        }
      }

      if (success) {
        this.saveCartLocking({
          code,
          beforeTime: before_time, // eslint-disable-line
        });
      } else {
        this.reason = 'Kunde inte reservera skidskolan.';
      }

      return success;
    },
    async addToCart() {
      const reserve = await this.reserve();

      if (!reserve) {
        this.available = false;
        return;
      }

      if (this.params.activity) {
        this.addActivitityToCart({
          pool_lid: this.school.pool_lid,
          people: this.theBooking.people,

          date: moment(this.theBooking.theDate).format('YYYY-MM-DD'),
          days: this.school.actual_days,
          site: this.school.site,

          activity_lid: this.theBooking.time,
          time: this.times.find(time => time.value === this.theBooking.time).title,

          quantity: this.theBooking.people.length,

          name: this.school.subtitle,

          price: this.price,

          guardian: this.theBooking.guardian,
          phone: this.theBooking.phone,
        });

        window.SKISCHOOL_alreadyBookedShowedWarning = false;

        this.closeModal();
        if (this.$store.state.isOnSite) {
          this.openModal(['OnSitePayment']);
        } else {
          this.$router.push({ name: 'shopping cart', query: { 'show-confirmation': 1, ref: 'activity' } });
        }
      } else {
        this.addSkiSchoolToCart({
          pool_lid: this.school.pool_lid,
          people: this.theBooking.people,

          date: moment(this.theBooking.theDate).format('YYYY-MM-DD'),
          days: this.school.actual_days,
          site: this.school.site,

          activity_lid: this.theBooking.time,
          time: this.times.find(time => time.value === this.theBooking.time).title,

          quantity: this.theBooking.people.length,

          name: this.school.subtitle,

          price: this.price,

          guardian: this.theBooking.guardian,
          phone: this.theBooking.phone,
        });

        this.consolidateSkiSchoolInCart({
          activity_lid: this.theBooking.time,
          price: this.price,
        });

        window.SKISCHOOL_alreadyBookedShowedWarning = false;

        this.closeModal();
        if (this.$store.state.isOnSite) {
          this.openModal(['OnSitePayment']);
        } else {
          const ref = this.$route.name === 'ski school overview' ? 'skischool' : 'bikeschool';
          this.$router.push({ name: 'shopping cart', query: { 'show-confirmation': 1, ref } });
        }
      }

      window.trackAddToCart({
        title: this.school.subtitle,
        lines: [{
          id: this.school.pool_lid,
          title: this.school.subtitle,
          category: 'skischool',
          quantity: this.theBooking.people.length,
          price: this.price,
        }],
      });
    },
    addPerson() {
      this.theBooking.people.push({ name: '', age: '', wishes: { hasWishes: false } });
    },
    removePerson() {
      this.theBooking.people
        .splice(this.theBooking.people.length - 1, 1);
    },
    async fetch() {
      const { data, meta } = await API.get(`/skischool/detail?pool=${this.params.pool}&id=${window.CURRENT_ACTIVITY_ID}&group=${this.params.presenterGroup}`);
      this.dates = data;
      this.school = meta;

      this.availableWishes = this.school.wishes || [];

      this.$nextTick(() => {
        if (!this.dates || !this.times.length) {
          this.theBooking.time = null;
        } else {
          this.theBooking.time = this.times[0].value;
        }

        this.loading = false;
      });

      window.trackViewItem({
        title: this.school.subtitle,
        lines: [{
          id: this.school.pool_lid,
          title: this.school.subtitle,
          category: 'skischool',
          quantity: 1,
          price: this.price,
        }],
      });
    },
    openDateModal() {
      this.$store.state.skiSchoolBooking = Object.assign({}, this.theBooking);
      const $this = this;
      this.openModal(['DatepickerRangeModal', {
        validDates: this.getDatesWithAccommodationRestrictions(
          Object.keys(this.dates),
        ),
        pickedStartDate: this.theBooking.theDate,
        pickedEndDate: null,
        onClose: (a) => {
          if (a) {
            $this.$store.state.skiSchoolBooking.theDate = a;
            $this.theBooking.theDate = a;
            window.CURRENT_ACTIVITY_ID = $this.dates[moment(a).format('YYYY-MM-DD')][0][5];
          } else {
            $this.$store.state.skiSchoolBooking.theDate = null;
            $this.theBooking.theDate = null;
            window.CURRENT_ACTIVITY_ID = null;
          }
          setTimeout(() => {
            $this.checkAvailability();
          }, 1);
        },
        startDateOnly: true,
        info: this.$i18n.t('skischool.pick-startdate-instruction'),
        open: (this.params.activity
          ? this.SITE_CONFIG.modules_open.activities.open
          : this.SITE_CONFIG.modules_open.school.open),
        closed_message: (this.params.activity
          ? this.SITE_CONFIG.modules_open.activities.closed_message
          : this.SITE_CONFIG.modules_open.school.closed_message),
        extraInfo: () => {
          const accommodationDateRange = this.getAccommodationDateRange();
          if (accommodationDateRange !== false) {
            return [`Endast tillgängliga datum inom ditt bokningsintervall (${accommodationDateRange.start.format('D MMMM')} - ${accommodationDateRange.end.format('D MMMM')}) visas.`];
          }

          return [];
        },
      }]);
    },
    selectDates(a) {
      this.theBooking.theDate = a;
    },
    dateClear() {
      this.theBooking.theDate = null;
    },
    closeLocalModal() {
      if (this.params.activity) {
        this.$router.go(-1);
      } else {
        this.closeModal();
        this.$store.state.skiSchoolBooking = {};
      }
      window.SKISCHOOL_alreadyBookedShowedWarning = false;
    },
    validated() {
      let valid = true;

      if (!this.theBooking.people.length) {
        return false;
      }
      if (!this.theBooking.theDate) {
        return false;
      }
      if (!this.theBooking.time) {
        return false;
      }
      if (!this.theBooking.guardian && this.showGuardian) {
        if (this.SITE_CONFIG.site === 'branas') {
          return false;
        }
        if (this.SITE_CONFIG.site === 'kungsberget') {
          return false;
        }
      }
      if (this.theBooking.phone.toString().match(/^\+[0-9]{9,13}$/) === null) {
        return false;
      }
      if (!this.$route.query.qty) {
        this.theBooking.people.forEach((person) => {
          if (!person.name) {
            valid = false;
          }
          const age = parseInt(person.age, 10);
          if (age >= this.school.minage && age <= this.school.maxage) {
            console.log('...');
          } else {
            valid = false;
          }
        });
      }

      if (!this.available) {
        valid = false;
      }

      // Is there wishes available and if so, check that they are valid
      if (this.showComments) {
        this.theBooking.people.forEach((person) => {
          if (!this.getWishesAsList(person.wishes).length) {
            valid = false;
          }
        });
      }

      return valid;
    },
    fixPhone() {
      this.theBooking.phone = this.theBooking.phone.replace(/^0/, '+46').replace(/^\+460/, '+46').replace(/[^+\w]/g, '');
    },
    pickWishes(payload) {
      Object.keys(payload).forEach((key) => {
        this.$set(
          this.theBooking.people[this.currentIndex].wishes,
          key,
          payload[key],
        );
      });
      this.theBooking.people[this.currentIndex].wishesAsText =
        this.getWishesAsListForSave(this.theBooking.people[this.currentIndex].wishes);
    },
    openWishes(index) {
      this.$store.state.skiSchoolBooking = Object.assign({}, this.theBooking);
      this.currentIndex = index;
      this.openModal(['SkiSchoolWishes', {
        click: this.pickWishes,
        person: this.theBooking.people[this.currentIndex],
        wishes: this.theBooking.people[this.currentIndex].wishes,
        poolId: this.school.pool_lid,
        availableWishes: this.availableWishes,
      }]);
    },
  },
  computed: {
    times() {
      const dt = moment(this.theBooking.theDate).format('YYYY-MM-DD');
      let dates = this.dates[dt];

      if (!dates || !dates.length) {
        return [];
      }

      dates = dates.map((time) => {
        if (!time) {
          return {};
        }
        return {
          value: time[1],
          price: time[2],
          title: time[0].substr(0, 5),
          min: time[4] || 1,
          max: time[3] || 1,
        };
      });

      return dates;
    },
    groupParticipantsRequirementText() {
      return this.$t('skischool.group-participants-requirement-text');
    },
    bookingNumber() {
      return '054-13 26 00';
    },
    lowParticipantCountVariationText() {
      return this.$t('skischool.low-participant-count-variation-text');
    },
    showGuardian() {
      const underAged = this.theBooking.people.filter(person => (person.age < 18 && person.age));

      if (this.params.activity) {
        return true;
      }

      return underAged.length;
    },
    price() {
      if (this.total_price) {
        return this.total_price / (this.theBooking.people.length || 1);
      }

      const theTime = this.times.find(time => time.value === this.theBooking.time);

      if (theTime) {
        return Math.round(parseFloat(theTime.price));
      }

      return this.school.price;
    },
    min() {
      const theTime = this.times.find(time => time.value === this.theBooking.time);

      if (theTime) {
        return theTime.min;
      }

      return 0;
    },
    max() {
      const theTime = this.times.find(time => time.value === this.theBooking.time);

      if (theTime) {
        return theTime.max;
      }

      return 0;
    },
    options() {
      const values = [
        { value: 0, title: this.$t('general.pick') },
      ];

      const min = this.min;
      const max = this.max;

      if (min) {
        let i = min;
        while (i <= max) {
          values.push({ value: i, title: `${i} ${this.$t('general.pieces-short')}` });
          i += 1;
        }
      }

      return values;
    },
    ages() {
      let i = this.school.minage;
      const max = this.school.maxage;
      const array = [];

      /* if (i === 3) {
        i = 0;
      } */

      while (i <= max) {
        array.push({
          value: i,
          title: `${i} ${this.$t('general.years')}`,
        });
        i += 1;
      }

      return array;
    },
    openCodeModal() {
      if (!this.validated()) {
        return false;
      }
      return true;
      // return this.openModal(['Checkout_deprecated_CodeModal', {
      //   goToPayment: true,
      //   goDirectly: this.$store.state.isOnSite,
      // }]);
    },
    showMinParticipantsReq() {
      return this.school.is_group && this.school.maxage >= 12;
    },
    lowParticipantCountVariations() {
      return this.school.is_group && this.school.maxage <= 10;
    },
    alreadyBooked: {
      cache: false,
      get() {
        const schools = this.$store.state.cart.skischools;

        console.log('check forcing', this.forceAlreadyBookedMessage);

        if (this.forceAlreadyBookedMessage) {
          return true;
        }

        if (!schools) {
          return '';
        }

        if (!schools.length) {
          return '';
        }

        const filtered = schools.filter(school => school.activity_lid === this.school.activity_lid);

        if (!filtered.length) {
          return '';
        }

        return true;
      },
    },
    alreadyBookedAges: {
      cache: false,
      get() {
        const schools = this.$store.state.cart.skischools;

        if (!schools) {
          return [];
        }

        if (!schools.length) {
          return [];
        }

        const filtered = schools.filter(school => school.activity_lid === this.school.activity_lid);

        if (!filtered.length) {
          return [];
        }

        return filtered.map(row => row.people.map(p => (p.age ? p.age : 30)).join(','));
      },
    },
    alreadyBookedMessage() {
      return 'Notera att om du bokar in flera elever i samma privatlektion och samma tidpunkt så kommer dessa troligtvis att bokas i samma grupp. Ring oss på tel 054-132600 om du önskar separata privatlektioner.';
    },
    restrictionDateInfo() {
      if (!this.theBooking.theDate) {
        return '';
      }

      const startDate = moment(this.theBooking.theDate);
      const endDate = moment(this.theBooking.theDate).add(this.school.days - 1, 'days');

      const isValid = this.areDatesWithinAccommodationRange(startDate, endDate);
      const range = this.getAccommodationDateRange();

      // First, check if the school starts before the arrival
      if (isValid === -1) {
        return `Du verkar ha valt skidskoledatum som startar före din ankomst (${range.start.format('D MMMM')}). Innan du går vidare, vänligen kontrollera att du har valt korrekt datum.`;
      }

      if (isValid === -2) {
        return `Du verkar ha valt skidskoledatum som startar efter din avresa (${range.end.format('D MMMM')}). Innan du går vidare, vänligen kontrollera att du har valt korrekt datum.`;
      }

      // Then, check if the school ends after the departure
      if (isValid === -3) {
        return `Du verkar ha valt skidskoledatum som slutar efter din avresa (${range.end.format('D MMMM')}). Innan du går vidare, vänligen kontrollera att du har valt korrekt datum.`;
      }

      return '';
    },
    showComments() {
      // Check if wishes
      if (this.getWishes().length > 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

h2
  font-size: 18px
  united-heavy()

.back
  background-color: #fff

.fully-disabled
  disabled()

.header
  padding space-3
  border-radius 3px 3px 0 0
  background-color pale-grey
  +max-mobile()
    padding-left padding-mobile
    padding-right padding-mobile
    padding-top padding-mobile
  .info-box
    display: flex
    justify-content: space-between
    border: 1px solid light-blue-grey
    border-radius: 3px
    background-color: white
    padding: space-1 space-2
    margin: space-2 0
    & > div
      &:not(:first-child)
        padding-left space-2
      &:not(:last-child):after
        content: ""
        border-left: 1px solid #ecf5f8
        margin-left: space-2
    +max-screen(350px)
      flex-wrap: wrap
      & > div
        width 100%
        &:not(:first-child)
          padding-left 0
          margin-top 6px
        &:not(:last-child):after
          content: ""
          border-left: 0
          margin-left: 0
  .location
    interstate()
    uppercase()
    margin: space-3 0 0
    .label
      @extends .bold
      margin-bottom: space-1
      font-size: 11px
      .icon
        position: relative;
        top: -2px
    .location-box
      border: 1px solid light-blue-grey
      border-radius: 3px
      background-color: white
      padding: 10px 15px;
      font-size: 12px
      font-weight: 300
      p
        font-size: 12px
        text-transform: none;
        font-weight: 300
      .icon
        margin-right: 3px
        margin-bottom: 7px
        position: relative;
        top 2px
      &.notice
        p
          margin-top: 10px
          font-size: 14px

.main
  padding: space-3
  padding-top space-1
  padding-bottom: 0px
  max-width 500px
  display flex
  flex-wrap: wrap;
  justify-content: space-between;
  p
    margin-top: 15px
    line-height: 1.2em
    font-size: 12px
    &.info-group-requirements
      margin-top: 0px
    &.info-call
      margin-bottom: 0px
  +max-mobile()
    padding-left padding-mobile
    padding-right padding-mobile
  .field
    width 100%
    &.half-size
      width 48%
    &.size-75
      width 71%
      +max-screen(350px)
        width 65%
    &.size-55
      width 51%
    &.size-25
      width 27%
      +max-screen(350px)
        width 33%
    &.size-20
      width 22%
    &.flex
      display flex
      flex-wrap: wrap;
      justify-content: space-between;
label
  text-transform: uppercase
  font-size: 11px
  letter-spacing: 0.02em
  margin-top: 14px
  margin-bottom: 3px

input
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 2px #bfd9e1;
  padding: 12px 10px 10px 10px

.footer
  display: flex
  justify-content: space-between
  align-items: center
  padding: space-3
  +max-screen(350px)
    flex-wrap wrap
    padding-top 0
  +max-mobile()
    padding-left padding-mobile
    padding-right padding-mobile
  .price
    interstate()
    font-size: 12px
    font-weight: 300
    color: #9e9e9e
    margin-right 10px
    +max-screen(350px)
      width 100%
      margin-bottom 10px
    span
      margin-left: space-half
      font-size: 26px
      font-weight: bold
      color: #262626
  button
    min-width: 220px
    position: relative
    top: -12px
    +max-screen(350px)
      top 0
    +max-mobile()
      width 50%

.checkboxes
  display flex
  & > div
    width 50px

hr
  border-top solid 2px #deebf0
  margin-top space-2

.phone-number
  margin: 0px
  width: 100%
  text-align: left;
  margin-top: 10px
  border-right: 0px solid #c2dbe263;
  font-size: 11px

.error
  error-box()
  p
    font-size 15px

.info
  info-box()
  info-box--blue()
  margin-top 15px
  margin-bottom 10px
  p
    font-size 15px
    margin-top: 0

.disabled
  disabled()

.awaiting
  top 30vh
</style>



// WEBPACK FOOTER //
// SkiSchoolBooking.vue?56373735